import RejectedQuestionBanner from './RejectedQuestionBanner.component';

export default RejectedQuestionBanner;